<template>       
  <v-card flat>
    <v-card-text v-if="fm" class="pa-0 v-data-table__wrapper" elevation="0">
      <v-container grid-list-xl class="pa-0">
        <v-layout row wrap v-if="fm.tingkat_id == 2">
          <v-flex xs12>
             <v-card class="yellow lighten-4">
              <v-card-text>
                <p>Kepada yang terhormat bapak/ibuk Ananda pendaftar SMP, silahkan klik link berikut untuk join dengan group whatsapp untuk informasi. Terima kasih.</p>
                <p><strong>Group 1</strong><br/>
                  <a target="_blank" :href="$config.group_wa_smp1">{{$config.group_wa_smp1}}</a>                
                </p>
                <p class="mb-0"><strong>Group 2</strong><br/>
                  <a target="_blank" :href="$config.group_wa_smp2">{{$config.group_wa_smp2}}</a>                
                </p>
              </v-card-text>
             </v-card>
          </v-flex>
        </v-layout>   
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card>
              <v-toolbar dense dark color="blue">
                <v-toolbar-title>Ujian Tahfizh Al-Qur'an</v-toolbar-title>
              </v-toolbar>
              <v-card-text>                
                <template v-if="!fm.test || (fm.test.quran != 0 && fm.test.quran != 1 && fm.test.quran != -1)">
                  <v-alert :value="true" color="info" icon="info" outline>
                    Ananda belum mengikuti tes baca Al-Quran                  
                  </v-alert>   
                  <v-card v-if="this.fm.test && this.fm.test.quran_sesi" class="mt-2" color="blue" dark>
                    <v-card-text>
                      Jadwal Tes Baca Alquran Ananda : {{quran_date}}  {{quran_sesi}}
                    </v-card-text>
                  </v-card>               
                </template>
                <template v-else>
                  <p class="subheading font-weight-regular text-xs-center">
                    <v-icon x-large class="blue--text">sentiment_very_satisfied</v-icon>
                    <h3 class="blue--text headline">Terima Kasih, ananda telah mengikuti tes baca Al-Quran</h3>     
                    silahkan mengikuti ujian tertulis pada waktu yang telah ditentukan. info lebih lanjut hub admin.
                  </p>
                </template>
                
                <!--<template v-else-if="fm.test.quran == 1">
                  <p class="subheading font-weight-regular text-xs-center">
                    <v-icon x-large class="green--text">sentiment_very_satisfied</v-icon>
                    <h3 class="green--text headline">Selamat ananda lulus tes baca Al-Qur'an</h3> 
                    silahkan mengikuti ujian tertulis pada waktu yang telah ditentukan. info lebih lanjut hub admin.
                  </p>
                </template>
                <template  v-else-if="fm.test.quran == 0">
                  <p class="subheading font-weight-regular text-xs-center">
                    <h3 class="orange--text headline">Semangat belajar, ananda harus mengulang tes baca Al-Quran kembali</h3>     
                    anda dapat melatih bacaan quran dan ikut tes kembali selama masa periode yang ditentukan.
                  </p>
                </template>
                <template  v-else-if="fm.test.quran == -1">
                  <p class="subheading font-weight-regular text-xs-center">
                    <v-icon x-large class="blue--text">sentiment_very_satisfied</v-icon>
                    <h3 class="blue--text headline">Terima Kasih, ananda telah mengikuti tes baca Al-Quran</h3>     
                    silahkan mengikuti ujian tertulis pada waktu yang telah ditentukan. info lebih lanjut hub admin.
                  </p>
                </template>-->
              </v-card-text>
              <v-divider />
              <v-card-text class="px-0 pr-2">
                <h3 class="mb-3 text-xs-center">SOP Ujian Tahfizh Al-Qur'an <br/>PPDB TP {{$config.tahun}}</h3>
                <ol>
                  <li>Ujian Al-Qur’an adalah rangkaian yang wajib diikuti oleh semua calon siswa/i Perguruan Islam Ar Risalah sebelum mengikuti rangkaian test lainnya baik di tingkat SMP maupun MA.</li>
                  <li>Setelah melakukan pendaftaran dan menyelesaikan administrasi pendaftaran, siswa akan diminta memilih jadwal ujian Qur’an.                   
                    <form @submit.prevent="simpanJadwal()">
                      <v-layout row wrap>
                        <v-flex xs7>
                          <v-text-field required v-model="quran_date" label="pilih tanggal" type="date" hide-details />                    
                        </v-flex>
                        <v-flex xs5>
                          <v-select required v-if="fm.gender == 1" :items="['sesi 1 pa','sesi 2 pa']" v-model="quran_sesi" label="pilih sesi" hide-details /> 
                          <v-select required v-if="fm.gender == 2" :items="['sesi 1 pi','sesi 2 pi']" v-model="quran_sesi" label="pilih sesi" hide-details /> 
                        </v-flex>  
                        <v-flex xs12 class="pt-0 px-0 mb-2">
                          <v-btn type="submit" small :loading="quran_loading">Simpan Jadwal</v-btn>
                        </v-flex>                    
                      </v-layout>
                    </form>
                    <p>
                      <strong>Jadwal Ujian Al-qur'an</strong><br/>
                      <ul>
                        <li>Hari Kerja Senin-Jumat
                          <ol>
                            <li>Sesi 1 (08.00-12.00) Maksimal 12 Pendaftar Pa dan Pi</li>
                            <li>Sesi 2 (14.00-15.30) Maksimal 5 Pendaftar Pa dan Pi</li>
                          </ol>
                        </li>
                        <li>Hari Sabtu & Ahad
                          <ol>
                            <li>Sesi 1 (08.00-12.00) Maksimal 24 Pendaftar Pa dan Pi</li>
                            <li>Sesi 2 (14.00-15.30) Maksimal 10 Pendaftar Pa dan Pi</li>
                          </ol>
                        </li>
                      </ul>
                    </p>                    
                  </li>
                  <li>Nilai ujian Al-Qur’an diambil dari akumulasi nilai tahsin (membaca) dan nilai hifzh (menghafal) dengan persentase nilai tahsin 60%  dan Hifzh 40%.</li>
                  <li>Nilai Tahsin adalah nilai yang diambil dari kemampuan calon siswa/i dalam membaca Al-Qur’an sesuai dengan Tajwid dan kelancarannya.</li>
                  <li>Nilai hifzh Al-Qur’an adalah nilai yang diambil dari kemampuan calon siswa/i dalam menghafal Al-Qur’an dengan standar berikut:
                    <ul>
                      <li>Tingkat SMP : Menghafal 3 baris dalam waktu 10 menit</li>
                      <li>Tingkat MA : Menghafal 5 baris dalam waktu 10 menit</li>
                    </ul>
                  </li>                  
                  <li>Standar kelulusan ujian Al-Quran adalah 85 (akumulasi nilai tahsin dan hifzh)</li>
                  <li>Test ujian Tahsin dan Hifzh Al-Qur’an dilaksanakan secara offline di Posko PPDB</li>
                  <li>Bagi calon siswa/i yang mempunyai Hafalan Al-Quran 3 juz atau lebih bisa mengambil jalur hafalan 3 juz dengan syarat hafalan yang dimiliki diujikan terlebih dahulu dg ketentuan:
                    1 Juz terdiri dari 4 soal (per 5 halaman 1 soal) dengan standar nilai perjuz 85
                  </li>
                  <li>Surah / Juz yang akan menjadi materi Tahsin dan Hifzh Al-Qur'an adalah Juz 6 – Juz 10 (Surah An-Nisa’ – Surah At-Taubah). </li>                  
                </ol>                
                <!--<p class="ma-2">NB: InsyaAllah untuk yang lulus Ujian Al-Qur'an akan kita update setiap hari senin.</p>-->
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6>
            <v-card v-if="fm.jalur_id == 1 || fm.jalur_id == 2">
              <v-toolbar dense color="green darken-3" dark>
                <v-toolbar-title>Ujian Akademik</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="v-table__overflow text-xs-center" style="height: 360px;" v-if="fm.tingkat_id > 1 && (fm.jalur_id == 1 || fm.jalur_id == 2)">      
                <center class="printcontent mb-4">                          
                  <div style="border: 1px solid #aaa; border-radius:20px; min-width:350px; width:350px;" class="blue lighten-2 white--text">
                    <v-layout row wrap>
                      <v-flex xs12 >
                        <table style="width:100%">
                          <thead>
                            <tr>
                              <th style="width:80px">
                                <img
                                  :src="require('@/assets/logo.png')"
                                  class="my-1"
                                  style="height:50px;"
                                />
                              </th>
                              <th>
                                <h4 style="font-size:12px" class="indigo--text">PERGURUAN ISLAM <span class="green--text">AR RISALAH</span></h4>
                                <h2 style="font-size:14px">Kartu Peserta Ujian</h2>                                            
                                <h4 style="font-size:12px">TAHUN AJARAN {{$config.tahun}}</h4>
                              </th>
                            </tr>
                          </thead>
                        </table>
                        <hr />
                      </v-flex>          
                      <v-flex xs12>  
                        <v-layout row wrap class="my-3">
                          <v-flex xs3 class="text-xs-left">
                            <div style="width:70px; height:70px; border:1px solid #eee; position: relative" class="text-xs-center mx-3 mb-2">
                              <img v-if="imgUrl" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:150px;" />
                              <span  @click="cropshow=true" v-else class="caption">Pas Foto</span>                               
                            </div>
                          </v-flex>
                          <v-flex xs9>
                            <table style="font-size:11px">
                              <tbody>
                                <tr>
                                  <td class="text-xs-left" valign="top"><strong>Nama Peserta</strong></td><td>:</td><td class="text-xs-left pl-1"><strong>{{fm.nama}}</strong></td>
                                </tr>
                                <tr>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td class="text-xs-left" valign="top">Nama Orang Tua</td><td>:</td><td class="text-xs-left pl-1">{{fm.ayah_nama}}</td>
                                </tr>
                                <tr>
                                  <td class="text-xs-left" valign="top">Jalur Masuk</td><td>:</td><td class="text-xs-left pl-1">
                                    <span v-if="fm.jalur_id == 1">Reguler</span>
                                    <span v-else-if="fm.jalur_id == 2">Prestasi</span>
                                    <span v-else-if="fm.jalur_id == 3">Internal</span>
                                    <span v-else-if="fm.jalur_id == 4">Undangan</span>
                                  </td>
                                </tr>                  
                                <tr>
                                  <td class="text-xs-left" valign="top">Nomor Ujian</td><td>:</td><td class="text-xs-left pl-1">{{fm.calonGedung.number}}</td>
                                </tr>                  
                              </tbody>
                            </table>                       
                          </v-flex>   
                        </v-layout>                                     
                      </v-flex>                           
                    </v-layout>        
                  </div>              
                </center> 
                <v-btn round v-if="fm.tingkat_id > 1" color="success" :loading="loadingActive" @click="printerPlugin()"><v-icon> print</v-icon> &nbsp; Cetak</v-btn>                                           
              </v-card-text>          
              <v-card-text class="text-xs-center v-table__overflow" v-if="!fm.test || (fm.test && !fm.test.ujian_nilai)" >                
                
                <template>
                  <p class="mt-5">
                  Klik button dibawah untuk menuju halaman ujian online <br/>
                  </p>
                  <v-btn round large color="success" class="mt-3" :disabled="ujian_config.disabled" @click="dialog=true">Ke Halaman Ujian</v-btn>   
                  <br/><small>tombol akan aktif pada hari ujian</small>
                  <!--<v-alert type="warning" value="true" class="text-xs-left" outline>
                    Ujian tes akademik Sabtu, 31 Oktober 2020 
                    <strong>Khusus SMP</strong> yang telah <strong>selesai registrasi</strong> sampai tanggal <strong>24 Oktober 2020</strong>
                    Untuk pendaftar setelah itu menunggu sesi ujian selanjutnya. Terima Kasih
                  </v-alert> -->   
                </template>
                <p class="text-xs-left">
                  <strong>Syarat dan Ketentuan</strong>
                  <ul>
                    <li>Ujian dilaksanakan secara Online</li>
                    <li>Jadwal tes akademik akan diumumkan melaui group whatsapp</li>                    
                  </ul>                  
                </p>
              </v-card-text>
              <v-card-text class="text-xs-center" v-else>
                <v-alert type="info" value="true"  class="text-xs-left">
                  Ananda telah selesai mengikuti semua rangkaian ujian. Terima Kasih.
                </v-alert>               
              </v-card-text>
            </v-card>           
          </v-flex>                      
        </v-layout>
        
        <v-dialog v-model="dialog" persistent max-width="290">        
          <v-card>
            <v-card-title class="headline">Mulai Ujian ?</v-card-title>
            <v-card-text>
              <strong>{{fm.nama}}, </strong>
              inputkan nomor ujian ananda pada kolom dibawah untuk masuk ke halaman ujian. lalu klik submit
              <v-text-field class="mt-2 mb-1" hide-details solo v-model="nomor_ujian" placeholder="nomor ujian" @keyup.enter="cekNomorUjian"    />
              <span v-if="nomor_ujian_error" class="red--text">nomor ujian anda salah, mohon cek kembali kartu ujian ananda, perhatikan tanda titik.</span>

              <p class="mt-3">inputkan token yang diinformasikan oleh pengawas ujian</p>
              <v-text-field class="mb-1" hide-details solo v-model="token_ujian" placeholder="token" @keyup.enter="cekNomorUjian"    />
              <span v-if="token_ujian_error" class="red--text">token salah, mohon cek kembali informasi dari pengawas ujian ananda.</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="dialog=false">Kembali</v-btn>
              <v-btn color="blue darken-1" flat @click="cekNomorUjian()" :loading="loadingCekNomorUjian">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>  
      </v-container>   
    </v-card-text>
    <v-card-text v-else>
      loading... please wait
    </v-card-text>
    <v-card-actions v-if="fm && fm.test">
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="fm.test.quran !== 1 && fm.jalur_id != 1" class="pa-1" @click="$emit('update:stepke', 7)">Continue</v-btn>
    </v-card-actions>
  </v-card>  
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
const  model = new Model();

export default {
  name:'step5',  
  props:{
    stepke:{
      type: Number,
      default: null,
    },
    fm:{
      type: Object
    }
  },  
  data:()=>({
    user : User.attributes(),
    stepkeLocal : null,    
    dialog:false,
    nomor_ujian:null,
    nomor_ujian_error:false,
    token_ujian:null,
    token_ujian_error:false,
    loadingCekNomorUjian:false,
    ujian_config : {
      disabled : true,
      token : null
    },    
    imgUrl:null,
    quran_date:null,
    quran_sesi:null,
    quran_loading:false,
    loadingActive:false
  }),  
  watch:{
    stepke(newStep){this.stepkeLocal = newStep},
    stepkeLocal(newStep){this.$emit('update:stepke', newStep); this.getavatar()},    
    'fm.test.quran_date'(ndate){
      this.quran_date = ndate      
      this.quran_sesi = this.fm.test.quran_sesi
    }    
  },
  mounted() {
    model.settings({key:'ujian_config'}).then(data=>{    
      if(Array.isArray(data.value)){
        let enabled = data.value.find(x=>x.name == 'enabled');
        if(enabled){
          this.ujian_config.disabled = enabled.childs && enabled.childs == 1 ? false:true
        }
        let token = data.value.find(x=>x.name == 'token');
        if(token){
          this.ujian_config.token = token.childs
        }
      }      
    });          
    this.getavatar()
  },
  methods:{
    simpanJadwal(){
      this.quran_loading = true;
      model.setQuranDate({quran_date:this.quran_date, quran_sesi:this.quran_sesi}).then(res=>{
        this.quran_loading = false;
        if(res.status == 200){
          window.getApp.$emit('showSnackbar', {
            show : true,
            text : 'Jadwal berhasil disimpan.',
            color: 'green'
          });
        } else {
          this.quran_date = null
          this.quran_sesi = null
        }
      })
    },

    cekNomorUjian(){
      this.nomor_ujian_error = false;
      this.loadingCekNomorUjian = true;
      setTimeout(()=>{
        if(this.nomor_ujian && this.fm.calonGedung && this.nomor_ujian.toLowerCase() == this.fm.calonGedung.number.toLowerCase()){          
          if(this.token_ujian && this.token_ujian == this.ujian_config.token){
            this.dialog = false
            this.$router.push({name:'ujian'});
          } else {
            this.token_ujian_error = true;  
          }
          
        } else {
          this.nomor_ujian_error = true;
        }
        this.loadingCekNomorUjian = false;
      }, 500);      
    },

    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.user.id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },

    printerPlugin(){
      this.conti = true;
      model.setCetak();
      print();
    }, 
  } 
};
</script>
<style>
input[type="date"]::-webkit-datetime-edit, input[type="date"]::-webkit-inner-spin-button, input[type="date"]::-webkit-clear-button {
  color: #fff;
  position: relative;
}

input[type="date"]::-webkit-datetime-edit-year-field{
  position: absolute !important;
  border-left:1px solid #8c8c8c;
  padding-left: 5px;
  color:#000;
  left: 65px;
}

input[type="date"]::-webkit-datetime-edit-month-field{
  position: absolute !important;
  border-left:1px solid #8c8c8c;
  padding-left: 4px;
  color:#000;
  left: 28px;
}

input[type="date"]::-webkit-datetime-edit-day-field{
  position: absolute !important;
  color:#000;
  padding-left: 2px;
  left: 4px;
  
}

.printcontent * {visibility: visible; color:#000;}  
.printcontent {position : relative; top:0px; left:0px; z-index: 0}  
@media print
{
    body * {visibility:hidden;}
    .printcontent * {visibility : visible;}
    .printcontent {position : fixed; top:0px; left:0px;}
}
</style>


